module.exports = "/_next/static/images/benefit-myhomecredit-app-37a912362bc28e9505db9bb6cf270d5b.png";